<app-view-package></app-view-package>
<div class="mb-3 mt-3">
    <button class="btn btn-primary me-2" (click)="onConfirm()" [disabled]="confirmed">
        <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
        Confirm
    </button>
    <button class="btn btn-outline-secondary me-2" type="button" (click)="onEdit()">
        Edit
    </button>
    <button class="btn btn-secondary" type="reset" (click)="onReset()">
        New Package
    </button>
</div>
